/**
 * GlobalUploadModal — Always-mounted upload orchestrator for global capture entries.
 *
 * Subscribes to ui$.activeModal === 'upload' to show/hide the upload modal.
 * Always adds articles to Inbox (listId = null).
 *
 * This component is mounted in Layout.jsx so it works from any route —
 * including ArticleReader and DeckView where ArticleImporter is not mounted.
 *
 * Snippet modal uses LOCAL state (snippetMode='local') to avoid double-render
 * conflict with ArticleImporter's snippet modal on list pages.
 *
 * Also mounts PdfGateModal (activeModal === 'pdfGate') for the PDF page range
 * selector triggered by useFileUpload when a large PDF is uploaded.
 */

import { useSelector } from '@legendapp/state/react';

import useFileUpload from '../hooks/useFileUpload';
import ImportModals from './ImportModals';
import PdfGateModal from './PdfGateModal';
import { ui$, closeModal } from '../store';

export default function GlobalUploadModal() {
  // Subscribe to the shared Sidebar / compact-header modal trigger.
  const showUploadModal = useSelector(() => ui$.activeModal.get() === 'upload');
  const showPdfGate = useSelector(() => ui$.activeModal.get() === 'pdfGate');

  // File upload hook — always targets Inbox (listId = null)
  const fileUpload = useFileUpload({ listId: null });

  return (
    <>
      <ImportModals
        listId={null}
        showUploadModal={showUploadModal}
        onCloseUploadModal={closeModal}
        snippetMode="local"
        fileUpload={fileUpload}
      />
      {showPdfGate && (
        <PdfGateModal
          onConfirm={fileUpload.confirmPdfGate}
          onCancel={fileUpload.cancelPdfGate}
        />
      )}
    </>
  );
}
